import request from "@/api/request";

export const getStoreTypesRequest = () => request.get("/store-types");
